import './subscribe-form.component.scss'
import IMask from 'imask'

function initLabels(activeClass) {
  document.querySelectorAll('.subscribe-form').forEach((controlContainer) => {
    //const labels = controlContainer.querySelectorAll('label')
    const controls = controlContainer.querySelectorAll('.control')/* ||
      controlContainer.querySelector('input[type="text"]') ||
      controlContainer.querySelector('textarea')*/

    controls.forEach((control) => {
      const label = control.querySelector('label')
      const controlInput = control.querySelector('input')
      if (controlInput.type === 'tel') {
        IMask(controlInput, {
          mask: '000 000-0000'
        })
      }
      else if (controlInput.type === 'email') {
        IMask(controlInput, {
          mask:  /^\S*@?\S*$/
        })
      }
      controlInput.addEventListener('focus', () => {
        label.classList.add(activeClass)
      })

      controlInput.addEventListener('blur', () =>{
        label.classList.toggle(activeClass, controlInput.value !== '')
      })

      label.classList.toggle(activeClass, controlInput.value !== '')
    })
  })
}

initLabels('is-float')
